const isEmpty = (val) =>
  val === undefined ||
  val == null ||
  val.length <= 0 ||
  Object.values(val).length <= 0;

const isStringAndNotNull = (str) => typeof str === 'string' && !(str === '');

export { isEmpty, isStringAndNotNull };
export default undefined;
